import { useI18n } from '../../i18n';

/** Language switcher (§6): a TEXT control labeled in its own language, never a flag. */
export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { t, toggleLocale } = useI18n();
  return (
    <button
      type="button"
      onClick={toggleLocale}
      className={`type-label text-secondary hover:text-primary focus-ring rounded-sm px-2 py-1 transition-colors duration-fast ease-machine ${className}`}
      lang={t.locale === 'es-MX' ? 'en-US' : 'es-MX'}
    >
      {t.otherLocaleName}
    </button>
  );
}
